import React, { useState } from 'react';
import styled from 'styled-components';
import RedScreenLayout from '../components/RedScreenLayout';
import TermsModal from '../components/TermsModal';
import { offerFootnote } from '../offer';

const Heading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 40px;
  line-height: 1.1;
  color: #ffffff;
  text-align: center;
  margin: 72px 24px 16px;
`;

const SubText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 16px;
  line-height: 1.4;
  color: #ffffff;
  text-align: center;
  margin: 0 auto 40px;
  width: 232px;
`;

const ClaimButton = styled.button`
  width: calc(100% - 32px);
  max-width: 360px;
  background: #ffbc0d;
  border: none;
  border-radius: 8px;
  padding: 18px 32px;
  font-family: 'Speedee Bold';
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  color: #2d2d2d;
  text-align: center;
  cursor: pointer;
  line-height: 1;
  position: relative;
  z-index: 3;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const InfoText = styled.p`
  font-family: 'Speedee Regular';
  font-size: 12px;
  line-height: 1.4;
  color: #ffffff;
  text-align: center;
  margin: 24px auto 40px;
  width: 328px;
  max-width: calc(100% - 32px);
  opacity: 0.7;
  text-shadow: -0.5px -0.5px 0 #db0007, 0.5px -0.5px 0 #db0007, -0.5px 0.5px 0 #db0007, 0.5px 0.5px 0 #db0007;
`;

function Home({ onClaimNow, offer }) {
  const [isLoading, setIsLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleTcsClick = () => {
    setShowTerms(true);
    window.gtag('event', 'mm-home-screen-btn-tcs');
  };

  const handleClaim = async () => {
    window.gtag('event', 'mm-home-screen-btn-claim');
    setIsLoading(true);
    try {
      await onClaimNow();
    } catch (e) {
      setIsLoading(false);
    }
  };

  return (
    <RedScreenLayout>
      <Heading>
        Hurry, claim your
        <br />
        <span>Big Mac®</span>
      </Heading>

      <SubText>Do it now before they're all gone!</SubText>

      <ClaimButton onClick={handleClaim} disabled={isLoading}>
        {isLoading ? 'PLEASE WAIT...' : 'CLAIM NOW'}
      </ClaimButton>

      <InfoText>
        {offerFootnote(offer)}{' '}
        <span onClick={handleTcsClick} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
          Terms & Conditions apply
        </span>
      </InfoText>

      {showTerms && <TermsModal onClose={() => setShowTerms(false)} />}
    </RedScreenLayout>
  );
}

export default Home;
